import { render, staticRenderFns } from "./quiz-category-list.vue?vue&type=template&id=1ad77a22&scoped=true"
import script from "./quiz-category-list.vue?vue&type=script&lang=js"
export * from "./quiz-category-list.vue?vue&type=script&lang=js"
import style0 from "./quiz-category-list.vue?vue&type=style&index=0&id=1ad77a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad77a22",
  null
  
)

export default component.exports